export const KEY_PARTNER_WINNER = '@BPOOL/partnerWinner';
export const KEY_PARTNERS_RATES = '@BPOOL/partnersRates';
